module.exports = __webpack_public_path__ + "img/electric_use.156d10ee.svg";